const videoElements = document.querySelectorAll('.video-wrapper video');
    videoElements.forEach((videoElement) => {
        const playpausebtn = videoElement.nextElementSibling;
        // console.log(playpausebtn, 'lv-video-loop__sound-button')
        const soundbtn = playpausebtn.querySelector(".lv-video-loop__sound-button");
        const soundoff = soundbtn.querySelector(".sound-off");
        const soundon = soundbtn.querySelector(".sound-on");
        if (soundbtn) {
            soundbtn.addEventListener("click", function(e) {
                e.preventDefault()
                if (videoElement.muted) {
                    document.querySelectorAll('video').forEach((otherVideo) => {
                        if (otherVideo != videoElement) {
                            otherVideo.muted = true;
                            const otherSoundButtons = otherVideo.nextElementSibling.querySelector(".lv-video-loop__sound-button");
                            if (otherSoundButtons) {
                                otherSoundButtons.querySelector(".sound-off").classList.remove("hide");
                                otherSoundButtons.querySelector(".sound-on").classList.add("hide");
                            }
                        }
                    });
                    videoElement.muted = !videoElement.muted;
                    soundon.classList.remove("hide");
                    soundoff.classList.add("hide");
                    videoElement.removeAttribute("muted");
                    this.classList.add('playing');
                } else {
                    videoElement.muted = true;
                    soundon.classList.add("hide");
                    soundoff.classList.remove("hide");
                    videoElement.setAttribute("muted" , "true");
                    this.classList.remove('playing');
                }
            })
        }
    })
const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        video.addEventListener("timeupdate", () => {
        video.classList.add("loaded");
        }, { once: true });
    });